const styles = (theme) => ({
  card: {
    width: 275,
    position: 'absolute',
  },
  margin: {
    margin: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export default styles
